import {MobXRepository} from "../../../repository/MobXRepository";
import {INltdevskeleton} from "../../nltdevskeletons/entity/nltdevskeletons/INltdevskeleton";

export interface IMenstrualCycleModel {
    menstrualCycle: INltdevskeleton[] | null;
}

class MenstrualCycleModel implements IMenstrualCycleModel {
    private menstrualCycleRepository = new MobXRepository<IMenstrualCycleModel['menstrualCycle']>(null);

    get menstrualCycle() {
        return this.menstrualCycleRepository.data;
    }

    set menstrualCycle(data: IMenstrualCycleModel['menstrualCycle']) {
        this.menstrualCycleRepository.save(data);
    }
}

export const menstrualCycleModel = new MenstrualCycleModel();